module.exports = __webpack_public_path__ + "img/404-error.720052b.png";